<template>
    <div>
      <v-select :clearable="false" id="category" name="category" :reduce="option => option.value" class="dream__category-select" :options="categoryOptions" v-model="category">
        <template v-slot:option="option">
          <vs-row vs-type="flex" vs-justify="flex-start">
            <feather-icon :icon="option.icon" svgClasses="h-5 w-5" v-if="option.icon" />
            <span class="ml-1">{{ option.label }}</span>
          </vs-row>
        </template>
      </v-select>

    </div>

</template>
<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    value: {
      type: null,
      required: false,
      default: () => null,
    },
    label: {
      type: String,
      required: false,
    },
  },
  data () {
    return {
      category: null,
      categoryOptions: [
        {label: '', value: 'other', icon: 'MinusIcon'},
        {label: 'Career & Business', value: 'career', icon: 'BriefcaseIcon'},
        {label: 'Finances', value: 'financial', icon: 'DollarSignIcon'},
        {label: 'Spirituality', value: 'spiritual', icon: 'SunriseIcon'},
        {label: 'Health & Fitness', value: 'physical', icon: 'ActivityIcon'},
        {label: 'Personal Growth', value: 'intellectual', icon: 'BookIcon'},
        {label: 'Family & Relationships', value: 'family', icon: 'HeartIcon'},
        {label: 'Fun & Recreation', value: 'social', icon: 'UsersIcon'},
      ]
    }
  },
  mounted () {
    this.category = this.value
  },
  watch: {
    category: {
      immediate: false,
      handler (category) {
        this.$emit('input', category)
      }
    }
  },
}
</script>

<style lang="scss">

.dream__category-select {
  background: #ffffff;
}

.theme-dark {
  .dream__category-select {
    background: #10163A;
  }

  .vs__dropdown-toggle {
    background: #10163A !important;
    border: 1px solid rgba(0, 0, 0, 0.2)
  }
}

</style>
